import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/campaign')({
  component: () => <Outlet />,
})
